export const ROOT = 'ROOT'
export const HUMIDITY_TEMP = 'HUMIDITY_TEMP'
export const HUMIDITY_TEMP_CO2 = 'HUMIDITY_TEMP_CO2'

export const typeGroups = [
  ROOT,
  HUMIDITY_TEMP,
  HUMIDITY_TEMP_CO2,
]
